/**
 * Count of glass widget cards that would render, from the same booleans as JSX (not DOM).
 *
 * @param flags
 */
const getGlassWidgetVisibleCardCount = (flags) =>
  (flags.showTodaysFocus ? 1 : 0) +
  (flags.showProgramStatus ? 1 : 0) +
  (flags.showAchievements ? 1 : 0) +
  (flags.showNotifications ? 1 : 0);

/**
 * Slots available for the middle carousel pool after pins consume `maxVisible`.
 *
 * @param maxVisible
 * @param pinnedSlotCount
 */
const getMiddleCarouselBudget = (maxVisible, pinnedSlotCount) => {
  if (!Number.isFinite(maxVisible) || maxVisible >= Number.MAX_SAFE_INTEGER) {
    return Number.POSITIVE_INFINITY;
  }
  return Math.max(0, Math.floor(maxVisible) - pinnedSlotCount);
};

/**
 * Number of middle carousel "pages" when paginating by `middleBudget` cards per page.
 *
 * @param middleLength
 * @param middleBudget
 */
const getMiddleCarouselPageCount = (middleLength, middleBudget) => {
  if (middleLength === 0) return 0;
  if (!Number.isFinite(middleBudget) || middleBudget >= Number.MAX_SAFE_INTEGER) return 1;
  if (middleBudget <= 0) return 0;
  return Math.ceil(middleLength / middleBudget);
};

/**
 * True when the middle stack should show prev/next (more than one page for the current budget).
 *
 * @param maxVisible
 * @param pinnedSlotCount
 * @param middleLength
 */
const getMiddleCarouselNeedsNav = (maxVisible, pinnedSlotCount, middleLength) => {
  const budget = getMiddleCarouselBudget(maxVisible, pinnedSlotCount);
  return getMiddleCarouselPageCount(middleLength, budget) > 1;
};

/**
 * Middle cards visible for `pageIndex` (0-based), `middleBudget` per page.
 *
 * @param middle
 * @param pageIndex
 * @param middleBudget
 */
const getMiddleCarouselPageSlice = (middle, pageIndex, middleBudget) => {
  if (middle.length === 0) return [];
  if (!Number.isFinite(middleBudget) || middleBudget >= Number.MAX_SAFE_INTEGER) {
    return [...middle];
  }
  if (middleBudget <= 0) return [];
  const start = pageIndex * middleBudget;
  if (start >= middle.length) return [];
  return middle.slice(start, start + middleBudget);
};

/**
 * Clamp carousel page index when middle length or budget changes.
 *
 * @param pageIndex
 * @param pageCount
 */
const clampMiddleCarouselPageIndex = (pageIndex, pageCount) => {
  if (pageCount <= 0) return 0;
  return Math.min(Math.max(0, pageIndex), pageCount - 1);
};

export default {
  getGlassWidgetVisibleCardCount,
  getMiddleCarouselBudget,
  getMiddleCarouselPageCount,
  getMiddleCarouselNeedsNav,
  getMiddleCarouselPageSlice,
  clampMiddleCarouselPageIndex,
};
